import React from 'react';

import { useNavigate } from 'react-router-dom';

const CreateAccountButton: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = (): void => {
    navigate('/app/accounts/create');
  };

  const RenderMovil: React.FC = () => {
    return (
      <button
        className="sm:hidden flex z-index bg-secondary-1.0 fixed w-12 h-12 flex-shrink-0 right-0 bottom-0 mr-6 mb-16 rounded-full"
        type="button"
        onClick={handleNavigate}
        data-testid="create-account-button"
      >
        <i className="text-white-0.0 m-auto icon-plus_icon text-xl" />
      </button>
    );
  };

  const RenderStandard: React.FC = () => {
    return (
      <button
        className="sm:flex btn btn-secondary hidden ml-auto"
        type="button"
        onClick={handleNavigate}
        data-testid="create-account-button"
      >
        <p className="text-white-0.0 font-semibold">Create new account</p>
      </button>
    );
  };

  return (
    <>
      <RenderStandard />
      <RenderMovil />
    </>
  );
};
export default CreateAccountButton;
